module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/21-88b391da4c60226f40bb27e2b77a0e77.png";